// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2CEIU","title":"FrontImage_title__1GNHe"};